import React from 'react';
import { MessageCircle, X } from 'lucide-react';
import { useTheme } from '../../utils/theme';

export function ChatButton({ onClick, isOpen }) {
  const { theme } = useTheme();
  const isDark = theme === 'dark';

  return (
    <button
      onClick={onClick}
      className={`fixed bottom-6 right-6 z-50 flex h-14 w-14 items-center justify-center rounded-full shadow-lg transition-all duration-200 hover:scale-110 ${
        isDark
          ? 'bg-white text-blue-900 hover:bg-gray-100'
          : 'bg-indigo-600 text-white hover:bg-indigo-700'
      }`}
      aria-label={isOpen ? 'Close chat' : 'Open chat'}
    >
      {isOpen ? (
        <X className="h-6 w-6" />
      ) : (
        <MessageCircle className="h-6 w-6" />
      )}
    </button>
  );
}
